var React = require('react');

function Map (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M32,1.3c-13.9,0-25.3,11-25.3,24.4c0,10.7,15.3,28.4,21.9,35.6c0.9,1,2.1,1.5,3.4,1.5c1.3,0,2.5-0.5,3.4-1.5 c6.6-7.1,21.9-24.9,21.9-35.6C57.3,12.2,45.9,1.3,32,1.3z M32.8,58.9c-0.5,0.5-1.2,0.5-1.6,0c-4.9-5.3-21-23.5-21-33.2 C10.2,14.1,20,4.8,32,4.8s21.8,9.4,21.8,20.9C53.8,35.4,37.7,53.5,32.8,58.9z","key":0}),React.createElement("path",{"d":"M32,15.7c-5.9,0-10.8,4.8-10.8,10.8c0,5.9,4.8,10.8,10.8,10.8s10.8-4.8,10.8-10.8C42.8,20.5,37.9,15.7,32,15.7z M32,33.7 c-4,0-7.3-3.3-7.3-7.3c0-4,3.3-7.3,7.3-7.3c4,0,7.3,3.3,7.3,7.3C39.3,30.4,36,33.7,32,33.7z","key":1})]);
}

Map.defaultProps = {"x":"0","y":"0","enableBackground":"new 0 0 64 64","version":"1.1","viewBox":"0 0 64 64","xmlSpace":"preserve"};

module.exports = Map;

Map.default = Map;
